import FiltrosLiquidaciones from '../../moleculas/FiltrosLiquidaciones/FiltrosLiquidaciones'

function FiltrosLiquidacionesContainer() {
  return (
    <div className="flex flex-row justify-between m-3">
      <FiltrosLiquidaciones/>
  </div>
  )
}

export default FiltrosLiquidacionesContainer